import { Link } from "react-router-dom";
import { pub } from "@/lib/pubThemeClasses";

/** Basit hukuki metin sayfası gölgesi (tam metin daha sonra güncellenir). */
export default function LegalDocument({ eyebrow, title, children }) {
  return (
    <div>
      <section className={`relative border-b bg-grain ${pub.borderSubtle}`}>
        <div className="absolute inset-0 grid-lines opacity-50 pointer-events-none" />
        <div className="relative mx-auto max-w-[900px] px-6 md:px-10 py-20 md:py-24">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4F00] mb-6">{eyebrow}</div>
          <h1 className={`font-display text-4xl sm:text-5xl font-black uppercase tracking-tight mb-8 ${pub.heroHeading}`}>{title}</h1>
          <div className="space-y-4 max-w-none">
            {children}
          </div>
          <Link to="/" className={`inline-block mt-12 font-mono text-xs uppercase tracking-[0.2em] text-[#FF4F00] transition-colors ${pub.hoverText}`}>
            Ana sayfa
          </Link>
        </div>
      </section>
    </div>
  );
}
